import { Home, Calendar, PaperPlus, Graph, Swap, Paper, Notification } from "react-iconly";
import {FiDatabase} from "react-icons/fi";
import IntlMessages from "../../layout/components/lang/IntlMessages";


const main = [
    {
        header: <IntlMessages id="sidebar-main" />,
    },
    {
        id: "sidebar-dashboard-eCommerce",
        title: <IntlMessages id="sidebar-dashboard-eCommerce" />,
        icon: <Home set="curved" />,
        navLink: "/po-dashboard",
    },
    {
        id: "sidebar-new-request",
        title: <IntlMessages id="sidebar-new-request" />,
        icon: <PaperPlus set="curved" />,
        navLink: "/po-dashboard/request-order",
    },
    {
        id: "sidebar-requests-page",
        title: <IntlMessages id="sidebar-requests-page" />,
        icon: <Paper set="curved" />,
        navLink: "/po-dashboard/requests-page",
    },
    {
        id: "sidebar-notification-list",
        title: <IntlMessages id="sidebar-notification-list" />,
        icon: <Notification set="curved"/>,
        navLink: "/notification-list",
    },
    {
        id: "sidebar-dashboard-options",
        title: <IntlMessages id="sidebar-dashboard-options" />,
        icon: <Swap set="curved"/>,
        navLink: "/dashboard-options",
    }
];


export default main